"use client";

import { useRouter } from 'next/navigation';
import { useState, useEffect } from "react";
const PrivacyPolicy = () => {

  const router = useRouter();
  const [isIndianUser, setIsIndianUser] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const detectUserLocation = () => {
      try {
        // Get user's timezone
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        
        // Indian timezones
        const indianTimezones = [
          'Asia/Kolkata',
          'Asia/Calcutta', 
        ];
        
        // Check if user is in Indian timezone
        const isIndian = indianTimezones.includes(timezone);
        setIsIndianUser(isIndian);
        
      } catch (error) {
        console.error('Error detecting timezone:', error);
        setIsIndianUser(false);
      } finally {
        setLoading(false);
      }
    };

    // Always detect location on component mount (every reload)
    detectUserLocation();
  }, []);

  const getIntroductionContent = () => {
    if (isIndianUser) {
      return (
        <p className="text-sm md:text-base">
         The website &quot;www.growthschool.io&quot; <span>(&quot;Website&quot;)</span> is owned
                and operated by Sisinty Private Limited, with its registered office
                at C/O Sisinty Hari Prasad, Prem Nagar, 7th Line, Last House,
                Berhampur, Odisha, 760001 <span>(&quot;Company&quot;)</span>.
        </p>
      );
    } else {
      return (
          <p className="text-sm md:text-base">
        The website &quot;www.growthschool.io&quot; <span>(&quot;Website&quot;)</span> is owned
                and operated by Sisinty Private Limited, with its registered office
                at 151 CHIN SWEE ROAD #07-12, MANHATTAN HOUSE, 169876 <span>(&quot;Company&quot;)</span>.
        </p>
      );
    }
  };




  
  // Simple hook to check if mobile


  return (
    <div className="w-full mt-30">
      <div className="w-[90%] md:w-[80%] mx-auto">
        <div className="mb-6 flex items-center gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            className="cursor-pointer"
            onClick={() => router.push('/')}
          >
            <path
              d="M10.4722 2.128C10.1942 1.91179 9.85214 1.7944 9.5 1.7944C9.14787 1.7944 8.80578 1.91179 8.52783 2.128L1.8905 7.28967C1.29517 7.75438 1.62292 8.70834 2.37738 8.70834H3.16667V15.0417C3.16667 15.4616 3.33348 15.8643 3.63041 16.1613C3.92735 16.4582 4.33007 16.625 4.75 16.625H7.91667V11.875C7.91667 11.4551 8.08348 11.0523 8.38042 10.7554C8.67735 10.4585 9.08007 10.2917 9.5 10.2917C9.91993 10.2917 10.3227 10.4585 10.6196 10.7554C10.9165 11.0523 11.0833 11.4551 11.0833 11.875V16.625H14.25C14.6699 16.625 15.0727 16.4582 15.3696 16.1613C15.6665 15.8643 15.8333 15.4616 15.8333 15.0417V8.70834H16.6226C17.3763 8.70834 17.7056 7.75438 17.1095 7.29046L10.4722 2.128Z"
              fill="#686C7A"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="6"
            height="9"
            viewBox="0 0 6 9"
            fill="none"
          >
            <path
              opacity="0.6"
              d="M1 0.5L5 4.5L1 8.5"
              stroke="#686C7A"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <a href="#" title="Refund Policy" className="text-sm font-normal">Privacy Policy</a>
        </div>
        
        <div>
          <div>
            <h1 className="text-2xl md:text-3xl">Privacy Policy</h1><br/>
            <p className="text-sm font-medium">Last Updated on 10th Feb 2025</p><br/>
          </div>
          
          <div className="privacy_policy">
            <div className="">
              {loading ? (
                <div className="animate-pulse">
                  <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                  <div className="h-4 bg-gray-200 rounded w-1/2 mb-2"></div>
                  <div className="h-4 bg-gray-200 rounded w-2/3"></div>
                </div>
              ) : (
                getIntroductionContent()
              )}<br/>
              
              <p className="text-sm md:textbase">
                The Company is, inter alia, engaged in the business of providing high – impact cohort-based courses on personal and professional growth (together, the <span>&quot;Services&quot;</span>).
              </p><br/>
              
              <p className="text-sm md:textbase">
                This Privacy Policy <span>(&quot;Privacy Policy&quot;)</span> sets out the privacy practices of the Company with respect to the entire content of the Website. 
              </p><br/>
              
              <div className="text-sm md:textbase">
                <p> This document is published in accordance with the provisions of the Information Technology Act, 2000, the Reasonable Security Practices and Procedures and Sensitive Personal Data or Information Rules, 2011 and the Digital Personal Data Protection Act, 2023 that require publishing the rules and regulations, privacy policy on an online portal of the Company. We request you to go through this Privacy Policy and the Terms of Use available at www.growthschool.io/in carefully before you decide to access this Website. 
                </p><br/>
                <p>
                  For the purposes of this Privacy Policy, the words &quot;us&quot;, &quot;we&quot;, and &quot;our&quot; refer to the Company and all references to &quot;you&quot;, &quot;your&quot; or &quot;user&quot;, as applicable mean the person who accesses, uses and/or participates in the Website in any manner or capacity.
                </p><br/>
                <p>
                  Anyone below 18 (eighteen) years of age is assumed to be a child <span>(&quot;Child&quot;)</span> and requires parental consent to use the Website. The parents/legal guardian of the Child or are hereinafter referred to as &quot;You&quot; or &quot;Your&quot;.
                </p>
                <br/>
                <p>
                  The protection and security of your personal information is one of our top priorities and we have taken all necessary and reasonable measures to protect the confidentiality of the user&apos;s information and its transmission through the internet. 
                </p><br/>
              </div>
              
              <p className="text-sm md:textbase text-bold">
                <span>
                  By using our Services and/or the Website or by otherwise giving us your information, you agree to the terms of this privacy policy. You also expressly consent to our use and disclosure of your Personal Information (as defined below) in the manner prescribed under this Privacy Policy and further signify your agreement to this Privacy Policy and the Terms of Use. If you do not agree to this Privacy Policy, do not subscribe to or use the Services, use the Website and do not give us any of your information. 
                </span><br/>
              </p><br/><br/>
            </div>
            
            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-3">Collection of Information</h2>
              <ul className="collection_inf"><br/>
                <li>
                  To the extent allowed by law, we are the sole owners of the information collected through the Website. To the extent we are not allowed to own the information under law, you hereby grant to us, a perpetual, royalty free and irrevocable license to use the information on the terms and conditions contained herein. We may collect and process personal information provided by you, including but not limited to:
                </li><br/>
                <li>
                  any information that you provide at the time of registration including any information that identifies or can be used to identify, contact or locate the user such as name, address, and phone number. 
                </li><br/>
                <li>
                  any information that you provide on our Website when you use our Services including log in and log out time. 
                </li><br/>
                <li>
                  any data that is automatically captured by the Website, such as the &quot;IP&quot; address (see below) from which the Website has been accessed. Every computer / mobile device connected to the internet is given a domain name and a set of numbers that serve as that computer&quot;s Internet Protocol or &quot;IP&quot; address. When you request a page from any page within the Website, our web servers automatically recognize your domain name and IP address. 
                </li><br />
                <li>RCS and SMS notifications are sent only to users who have voluntarily signed up and provided explicit consent to receive updates via these channels. We do not share or sell subscribers’ or customers’ information to any third party for marketing purposes. Your privacy is always respected, and you may choose to opt out of receiving RCS or SMS notifications at any time through the unsubscribe/opt-out options provided in the messages or by contacting us.</li>
              </ul>
              
              <p className="text-sm md:textbase">
                hereinafter, collectively referred to as <span>&quot;Personal Information.&quot;</span>
              </p><br/><br/>
              
              <p className="text-sm md:textbase">
                In the event the Website is proposed to be used by a Child, we require Your consent before providing Your Child with access to the Website and its Services (as outlined under the Terms and Conditions). As Your Child is a minor, under applicable laws, we cannot collect, process or store any information pertaining to Your Child without Your consent. Without Your consent, we will not be able to collect and/or process the necessary information, and therefore cannot provide access to the Services available through our Website. You, as the parent/guardian, are the primary account holder on behalf of Your Child. This means that:
              </p><br/>
              
              <p className="text-sm md:textbase">
                You are the person primarily responsible for ordering Services and paying any fees or other charges made to us.
              </p><br/>
              
              <p className="text-sm md:textbase">
                You are responsible for deciding whether to share Your Child&apos;s content with us and relevant third parties.
              </p><br/>
              
              <p className="text-sm md:textbase">
                You are responsible for the active monitoring of Your Child&apos;s content. Children are expressly prohibited from including any personally identifiable information in any content that they post to our website in accordance with the Terms and Conditions unless or until their parents or legal guardians give permission. You agree that You will only allow Your child to include any personally identifiable information in their content with Your consent. We shall therefore assume that any personally identifiable information posted by Your Child has been done so with Your express permission and consent.
              </p><br/>
              
              <p className="text-sm md:textbase">
                You hereby explicitly consent and grant permission to us to gather information and data including Personal Information (defined below) with respect to the courses that are conducted on the Website by the instructors for (a) the purpose of improving the Services offered by the Company, (b) quality and internal training purposes (c) the reasons specified in this Privacy Policy and/or (d) such other purposes as may be informed to You from time to time.
              </p><br/>
              
              <p className="text-sm md:textbase">
                <span><span className='underline font-semibold'>Use of Information Collected</span><br/>
                Use of Personal Information for Services
                </span>
              </p><br/>
              
              <p className="text-sm md:textbase">
                The primary goal of the Company in collecting Personal Information is to provide you with an online platform for the purpose of providing the Services. The Company may use Personal Information provided by you in the following ways:
              </p><br/>
              
              <p className="text-sm md:textbase">
                To provide and help provide you the Services; 
              </p><br/>
              
              <p className="text-sm md:textbase">
                To observe, improve and administer the quality, features and functionality of the Services;
              </p><br/>
              
              <p className="text-sm md:textbase">
                To analyze how the Website is used and to diagnose technical problems;
              </p><br/>
              
              <p className="text-sm md:textbase">
                Remember basic Personal Information provided by you for effective access;
              </p><br/>
              
              <p className="text-sm md:textbase">
                To confirm your identity in order to determine your eligibility to use the Website and avail the Services;
              </p><br/>
              
              <p className="text-sm md:textbase">
                To notify you about any changes to the Website;
              </p><br/>
              
              <p className="text-sm md:textbase">
                To enable the Company to comply with its legal and regulatory obligations;
              </p><br/>
              
              <p className="text-sm md:textbase">
                For the purpose of sending administrative notices, Service-related alerts and other similar communication with a view to performing the Services effectively and optimizing the efficiency of the Website;
              </p><br/>
              
              <p className="text-sm md:textbase">
                To notify you about any changes to the Website;
              </p><br/>
              
              <p className="text-sm md:textbase">
                To enable the Company to comply with its legal and regulatory obligations;
              </p><br/>
              
              <p className="text-sm md:textbase">
                Doing market research, troubleshooting, protection against error, project planning, fraud and other criminal activity; 
              </p><br/>
              
              <p className="text-sm md:textbase">
                To enforce the Company&apos;s Terms of Use; and 
              </p><br/>
              
              <p className="text-sm md:textbase">
                To incorporate plugins and/or buttons for social networks, in order to allow easy sharing on your favorite social networks. These plugins are programmed so as not to set any cookies when assessing the page to safeguard the privacy of users. Cookies may be set, if you make voluntary use of the plugin. The collection and use of information obtained by means of the plugin are governed by the respective privacy policies of the social networks.
              </p><br/>
              
              <p className="text-sm md:textbase">
                <span>Sale of Assets, Merger, Acquisition, Bankruptcy</span>
              </p><br/>
              
              <p className="text-sm md:textbase">
                Information collected from you may be transferred to a third party as a result of a sale or acquisition, merger or bankruptcy involving the Company. 
              </p><br/><br/>
            </div>
            
            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-3">Cookies</h2>
              <div className="information_collected">
                <p>
                  Cookies are small portions of information saved by your browser onto your computer / mobile / tablet or other devices. 
                </p><br/>
                <p>
                  Cookies are used to record various aspects of your visit and assist the Company to provide you with uninterrupted service. 
                </p><br/><br/>
              </div>
            </div>
            
            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-3">Sharing of Information</h2>
              <h3 className="text-base md:text-xl font-medium mb-3">Sharing</h3>
              <p>
                Other than as mentioned elsewhere in this Privacy Policy, the Company may share personally identifiable information with the Company&apos;s partners or affiliates, including but not limited to Google Ads, Meta, LinkedIn, Mixpanel and Posthog. This is not linked to any Personal Information that can identify an individual person. The Company will not be liable for transfer of any Personal Information resulting from loss or distribution of data, or corruption of media storage, power failures, natural phenomena, riots, act(s) of vandalism, sabotage, terrorism and any other event beyond the Company&apos;s reasonable control, including due to acts or omissions of third parties. Further, the Company&apos;s Privacy Policy does not cover the use of cookies by its partners and affiliates since the Company does not have access or control over such cookies. 
              </p><br/><br/>
            </div>
            
            <div className="policy_item">
              <div className="sharing_inf">
                <div className="sharing_inf_item">
                  <h3 className="text-sm md:text-base font-medium mb-2">Consulting</h3>
                  <p>
                    The Company may partner with another party to provide specific Services if required. When you sign-up for the Services, the Company will share names or other Personal Information that is necessary for the third party to provide these Services. The Company shall make efforts to ensure that the Company&apos;s arrangements with such third parties restrict these parties from using personally identifiable information except for the explicit purpose of assisting in the provision of these Services.   
                  </p><br/><br/>
                </div>
                
                <div className="sharing_inf_item">
                  <h3 className="text-sm md:text-base font-medium mb-2">Regulatory Disclosures</h3>
                  <p>
                    In the event the Company is required to disclose any Personal Information by law, rule, regulation, enforcement, governmental official, legal or regulatory authorities or any other statutory bodies, court orders or other legal process or for any tax authorities <span>(&quot;Required Disclosures&quot;),</span> your Personal Information may be disclosed pursuant to such Required Disclosures. The Company may be required to disclose Personal Information of users effecting payments in INR, for taxation purposes, with the National Skill Development Corporation, which disclosure would also be a &quot;Required Disclosure&quot;. Required Disclosures may be made without notice to you. The Company may further disclose your Personal Information to such third parties to whom it transfers its rights and duties under any agreement entered into with such third parties and may also disclose your Personal Information to any of its affiliates or related entities. 
                  </p><br/><br/>
                </div>
                
                <div className="sharing_inf_item">
                  <h3 className="text-sm md:text-base font-medium mb-2">Link to Third Party Websites</h3>
                  <p>
                    This Website may contain links which may lead you to other websites. Please note that once you leave the Company&apos;s Website you will be subjected to the privacy policy of the other website. The linked sites are not necessarily under the control of the Company. Please be aware that the Company is not responsible for the privacy practices of such other websites. The Company encourages you to read the privacy policies of each and every website that collects Personal Information. If you decide to access any of third-party sites linked to the Website, you do this entirely at your own risk. Any links to any third-party partner of the Company should be the responsibility of such third party providing the linking facility, and the Company will not be responsible for notification of any change in the name or location of any information on the third-party website.
                  </p><br/><br/>
                </div>
                
                <div className="sharing_inf_item">
                  <h3 className="text-sm md:text-base font-medium mb-2">Disclosure to Other Service Recipients</h3>
                  <p>
                    You hereby permit the Company to disclose to disputants, dispute resolution professionals, witnesses and legal counsel <span>(&quot;Other Service Recipients&quot;)</span> your Personal Information to the extent such disclosure is required - (a) for you to avail the Services; or (b) by the rules of the Company or any third party for resolution of disputes on the Website; or (c) by applicable law.  
                  </p><br/><br/>
                </div>
                
                <div className="sharing_inf_item">
                  <h3 className="text-sm md:text-base font-medium mb-2 underline">Non-Disclosure of Information</h3>
                  <p>
                    The Company pledges that it will not sell or rent your Personal Information to anyone and your Personal Information will be protected and maintained strictly confidential by the Company except in the following cases:
                  </p><br/>
                  <p>
                    A Required Disclosure of your Personal Information;
                  </p><br/>
                  <p>
                    The Company may disclose your Personal Information in order to provide you the Services, enforce or apply the Terms of Use, or to protect the rights, property or safety of the Company, its users or others. This includes exchanging information with other companies / agencies that work for fraud prevention;
                  </p><br/>
                  <p>
                    The Company may disclose your Personal Information to such third parties to whom it transfers its rights and duties under any agreement entered into with such third parties; and
                  </p><br/>
                  <p>
                    The Company may disclose your Personal Information to any of its affiliates or related entities. 
                  </p><br/><br/>
                </div>
              </div>
            </div>
            
            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-2">Security of Information</h2>
              <ul className="security_inf">
                <li>
                  The Company has put in place appropriate methods and managerial procedures to safeguard and secure Personal Information. The Company only processes Personal Information in a way that is compatible with and relevant for the purpose for which it was collected from or authorized by the user. 
                </li><br/>
                <li>
                  The Company uses commercially reasonable precautions to preserve the integrity and security of your Personal Information against loss, theft, unauthorised access, disclosure, reproduction, use or amendment.
                </li><br/>
                <li>
                  Personal Information that is collected from you may be transferred to, stored and processed at any destination within and / or outside India. By submitting Personal Information on the Website, you agree to this transfer, storing and / or processing. The Company will take such steps as it considers reasonably necessary to ensure that your Personal Information is treated securely and in accordance with this Privacy Policy.
                </li><br/>
                <li>
                  In using the Website, you accept the inherent security implications of data transmission over the internet. Therefore, the use of the Website will be at your own risk and the Company assumes no liability for any disclosure of Personal Information due to errors in transmission, unauthorised third party access or any other acts of third parties, or acts or omissions beyond its reasonable control and you agree not to hold the Company responsible for any breach of security whether arising due to errors in transmission or due to any acts of third parties.
                </li><br/>
                <li>
                  In the event the Company becomes aware of any breach of the security of your Personal Information, it will promptly notify you and take appropriate action to the best of its ability to remedy such a breach. 
                </li><br/><br/>
              </ul>
            </div>
            
            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-2 underline">Exclusion</h2>
              <p>
                6.1 This Privacy Policy does not apply to any information other than information collected by the Company through the Website including such information collected in accordance with the clause on &quot;Collection of Information&quot; above. This Privacy Policy will not apply to any unsolicited information provided by you through this Website or through any other means. This includes, but is not limited to, information posted on any public areas of the Website. All such unsolicited information shall be deemed to be non-confidential and the Company will be free to use, disclose such unsolicited information without limitation.
              </p><br/>
              <p>
                6.2 The Company also protects your Personal Information off-line other than as specifically mentioned in this Privacy Policy. Access to your Personal Information is limited to employees, agents or partners and third parties, who the Company reasonably believes will need that information to enable the Company to provide the Services. However, the Company is not responsible for the confidentiality, security or distribution of Personal Information by our partners and third parties outside the scope of our agreement with such partners and third parties.   
              </p><br/><br/>
            </div>
            
            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-2 underline">Data Retention</h2>
              <p>
                The Company shall not retain Personal Information longer than is necessary to fulfil the purposes for which it was collected and as permitted by applicable law. If you wish to cancel your account or request that the Company, no longer use your information to provide you Services, contact us through email at hi@growthschool.io. However, even after your account is terminated, the Company may retain your Personal Information as needed to comply with our legal and regulatory obligations, resolve disputes, conclude any activities related to cancellation of an account, investigate or prevent fraud and other inappropriate activity, to enforce our agreements, and for other business reasons. 
              </p><br/><br/>
            </div>
            
            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-2 underline">Right To Withdraw Consent</h2>
              <p>
                The consent that you provide for the collection, use and disclosure of your Personal Information will remain valid until such time it is withdrawn by you in writing. If you withdraw your consent, the Company will stop processing the relevant Personal Information except to the extent that the Company has other grounds for processing such Personal Information under applicable laws. The Company will respond to your request within a reasonable timeframe. You may withdraw your consent at any time by contacting the Company or by using the functionalities of the Website. However, please note that consent with respect to the pleadings and documents related to any dispute you wish to resolve using the Services, may not be withdrawn.
              </p><br/><br/>
            </div>
            
            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-2 underline">Right to Correction</h2>
              <p>
                You are responsible for maintaining the accuracy of the information you submit to us, such as your contact information provided as part of account registration. The Company relies on the users to disclose to it all relevant and accurate information and to inform the Company of any changes. If you wish to make a request to correct or update any of your personal data which we hold about you, you may submit your request in writing or via email to hi@growthschool.io. 
              </p><br/><br/>
            </div>
            
            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-2 underline">Data Transfer</h2>
              <p>
                The Company may transfer information that it collects about you, including Personal Information, to affiliated entities, or to other third parties across borders and from your country or jurisdiction to other countries or jurisdictions around the world. These countries may have data protection laws that are different from the laws of your country and, in some cases, may not be as protective. The Company shall take appropriate safeguards to ensure that your Personal Information will remain protected in accordance with this Privacy Policy. 
              </p><br/><br/>
            </div>
            
            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-2 underline">Notification of Changes</h2>
              <p>
                From time to time, the Company may update this Privacy Policy to reflect changes to its information practices. Any changes will be effective immediately upon the posting of the revised Privacy Policy. If the Company makes any material changes, it will notify you by email (sent to the e-mail address specified in your account) or by means of a notice on the Services prior to the change becoming effective. We encourage you to periodically review this page for the latest information on our privacy practices.
              </p><br/><br/>
            </div>
            
            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-2 underline">Opt Out Procedures</h2>
              <p>
                Upon communication from the Company, you may at any time, opt-out of receiving further communications including newsletters from the Company. To be completely removed from the Company&apos;s mailing list, you may contact us at hi@growthschool.io. If you are using an e-mail forwarding service or any other similar service, please make sure to include the correct e-mail address or addresses. 
              </p><br/><br/>
            </div>
            
            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-2 underline">Grievance Officer</h2>
              <p>
                In accordance with the Information Technology Act, 2000 and the rules made thereunder, the name and contact details of the grievance officer are provided below:
              </p><br/><br/>
            </div>
            
            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-2 underline">Grievance Officer</h2>
              <div className="officer">
                <p>Name: S Chaitanya</p>
                <p>Email ID: grievance@growthschool.io</p>
                <p>Phone: 6360754645</p>
              </div><br/><br/>
            </div>
            
            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-2 underline">Address for Privacy Questions</h2>
              <p>
                Should you have questions about this Privacy Policy or Company&apos;s information collection, use and disclosure practices, you may contact us at hi@growthschool.io. We will use reasonable efforts to respond promptly to requests, questions or concerns you may have regarding our use of Personal Information about you. Except where required by law, the Company cannot ensure a response to questions or comments regarding topics unrelated to this policy or the Company&apos;s privacy practices. 
              </p><br/>
            </div>
            
            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-2 underline">CCPA Specific Provisions</h2>
              <p>
                The Company also complies with the California Consumer Privacy Act <span>(&quot;CCPA&quot;)</span> as approved on August 14, 2020. The Company believes and supports the five general rights for personal information under the CCPA, including right to know what information is being collected, the right to know if information is being sold/disclosed and to opt-out of such sale, the right to access personal information collected, the right to have such personal information collected be deleted, the right of non-discrimination for exercising their rights under the CCPA. 
              </p><br/>
              <p>
                The Company is also in compliance with requirements of the Controlling the Assault of the Non – Solicited Pornography and Marketing Act, 2003.
              </p><br/>
            </div>
            
            <div className="policy_item">
              <h2 className="text-base md:text-xl font-medium mb-2 underline">You have read this Privacy Policy and agree to all of the provisions contained above.</h2>
            </div><br/><br/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;